import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onRetry, onDismiss }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Alert
        severity="error"
        icon={<WarningIcon />}
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            {onRetry && (
              <Button color="inherit" size="small" onClick={onRetry}>
                Thử lại
              </Button>
            )}
            {onDismiss && (
              <Button color="inherit" size="small" onClick={onDismiss}>
                Đóng
              </Button>
            )}
          </Box>
        }
      >
        {message}
      </Alert>
    </Box>
  );
};
